import { Fragment } from "react";


const Samples = () => {

    return (
        <Fragment>
            <h2 className="">Past Projects</h2>
            <ul className="">
                <li><a href="https://ul.com" target="_blank" rel="noopener noreferrer">ul.com</a></li>
                <li><a href="http://mblm.com" target="_blank" rel="noopener noreferrer">mblm.com</a></li>
                <li><a href="https://www.princetonmagazine.com/" target="_blank" rel="noopener noreferrer">princetonmagazine.com</a></li>
            </ul>
        </Fragment>)
}

export default Samples;


//coin buy sell, quantity, tax, net profit